module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_chestnut.e4407bbd.png";